import React, { useState } from "react";
import "../layout/css/style.css";
import Footer from "../layout/Footer.js";
import FAQ from "../widgets/WidgetFAQLucknow.js";
import Price_Lead_Form from "../widgets/forms/price/widget-action-price-form.js";
import ShortLeadForm from "../widgets/forms/price/short-lead-form.js";
import mentalhealth from "../assets/Images/banner-hearing-aids-centre.webp";
import righthearingaids from "../assets/Images/find-the-right-hearing-aids.webp";
import Bookhearingtest from "../assets/Images/book-a-free-hearing-test.webp";
import BTE from "../assets/Images/bte.webp";
import CIC from "../assets/Images/cic_beige.webp";
import RechargeableHA from "../assets/Images/signia-rechargeable.webp";
import BluetootHA from "../assets/Images/Phonak-Audeo-Paradise.webp";
import LeadFormPOPUP from "../widgets/forms/widget-action-price-popup-form.js";
import { Helmet } from "react-helmet";
import LiteYouTubeEmbed from 'react-lite-youtube-embed';
import 'react-lite-youtube-embed/dist/LiteYouTubeEmbed.css';
import signiaImg from "../assets/Images/privileged-partner-signia.webp";
import phonakImg from "../assets/Images/authorised-partner-phonak.webp";
import resoundImg from "../assets/Images/authorised-partner-resound.webp";

const PriceLucknow = () => {
  const [isFormOpen, setIsFormOpen] = useState(false);
  return (
    <>
      <Helmet>
        <meta charset="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no" />
        <meta http-equiv="x-ua-compatible" content="ie=edge" />
        <title>Hearing aids at SFL come with pocket-friendly prices and lifetime addon benefits - SFL Hearing Solutions</title>
        <meta name="description" content="Purchase your hearing aids once you are fully satisfied with listening experience. Book your hearing aid trial now." />
        <meta name="robots" content="INDEX, FOLLOW" />
        <link rel="canonical" href="https://ads.soundforlife.in/hearing-aids-price-lucknow" />
        <meta name="DC.title" content="Best hearing aid solution - Book a hearing aid trial now - SFL Hearing Solutions" />
        <meta property="og:locale" content="en_US" />
        <meta property="og:site_name" content="SFL Hearing Solutions" />
        <meta property="og:title" content="Best hearing aid solution - Book a hearing aid trial now - SFL Hearing Solutions" />
        <meta property="og:description" content="Purchase your hearing aids once you are fully satisfied with listening experience. Book your hearing aid trial now." />
        <meta property="og:type" content="Website" />
        <meta property="og:image" content="https://ads.soundforlife.in/assets/images/og-image.jpg" />
        <meta property="og:image:type" content="image/jpeg" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta property="og:image:alt" content="Best hearing aid solution - Book a hearing aid trial now - SFL Hearing Solutions" />
        <meta property="og:url" content="https://ads.soundforlife.in/hearing-aids-price-lucknow" />
        <link rel="preload" as="image" href={mentalhealth} />
      </Helmet>
      {/* Header Section */}
      <header className="bg-primary bg-opacity-50 py-5">
        <div className="container">
          <div className="row align-items-center g-5">

            {/* Banner Column */}

            <div className="col-lg-7 position-relative">
              <div className="position-relative">
                <img
                  src={mentalhealth} width="190" height="143" alt="hearing aids"

                  className="img-fluid w-100 rounded shadow lcp-img" fetchpriority="high"

                />
                <div className="banner-overlay position-absolute bottom-0 start-0 w-100 bg-dark bg-opacity-50 text-white p-4">
                  <h1 className="h2 h1-md fw-bold">Affordable Hearing Aids in Lucknow – Choose the Right
                    One for You</h1>
                  <p className="mb-0">
                    <span className="tag bg-success fw-bold me-2">
                      <i className="fa-solid fa-users me-1"></i> Hear Better
                    </span>
                    <span className="tag bg-success fw-bold me-2">
                      <i className="fa-solid fa-microchip me-1"></i> Feel Confident Again
                    </span>
                    <span className="tag bg-success fw-bold">
                      <i className="fa-solid fa-indian-rupee-sign me-1"></i> Affordable Prices
                    </span>
                  </p>
                </div>
              </div>
            </div>

            {/* Form Column */}

            <div className="col-lg-5">
              <Price_Lead_Form />
            </div>

          </div>
        </div>
      </header>

      {/* Main Content Section */}
      <div className="container mt-5">
        {/* Bullet Points */}
        <div className="mb-4 text-center">
          <span className="d-block d-md-inline-block mb-2 me-md-3 fs-4">
            <i className="fa-solid fa-check-circle text-success me-1"></i> Hearing Test
          </span>
          <span className="d-block d-md-inline-block mb-2 me-md-3 fs-4">
            <i className="fa-solid fa-check-circle text-success me-1"></i> Branded Digital Hearing Aids
          </span>
          <span className="d-block d-md-inline-block fs-4">
            <i className="fa-solid fa-check-circle text-success me-1"></i> Expert Audiologists
          </span>
        </div>

        {/* Intro */}
        {/*  <h2 className="section-title">
          Best Prices on Hearing Aids in Lucknow
        </h2> */}
        <h2 className="fw-bold display-6 title">Best Prices On <span className="title-info">Hearing Aids in Lucknow</span></h2>

        <p>
          <i className="fa-solid fa-location-dot text-primary me-1 font-icon" ></i>
          Are you trying to find a kan ki machine or{' '}
          <span className="tag">hearing aid in Lucknow?</span> We’re here to help you find
          the perfect hearing solution at a cost that suits your spending plan. SFL Hearing Solutions
          provides a wide range of devices to fit every need and budget, whether you need a small ear
          machine for daily comfort or a pocket hearing aid for profound hearing loss.
        </p>
        <p>
          Whether you need a kan ki machine, ear device for hearing loss, or a pocket hearing aid
          for profound hearing loss, we’ve got you covered.
        </p>

        {/* Best Prices on Hearing Aids */}

        <div className="table-responsive">
          <table className="table table-bordered table-striped mt-3">
            <thead className="table-primary">
              <tr>
                <th scope="col">Type</th>
                <th scope="col">Price</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td><i className="fa-solid fa-ear-listen font-icon me-2"></i>BTE (Behind-the-Ear)</td>
                <td><i className="fa-solid fa-indian-rupee-sign font-icon me-2"></i>₹19,990 Onwards</td>
              </tr>
              <tr>
                <td><i className="fa-solid fa-ear-listen font-icon me-2"></i>CIC (Completely-in-Canal)</td>
                <td><i className="fa-solid fa-indian-rupee-sign font-icon me-2"></i>₹24,990 Onwards</td>
              </tr>
              <tr>
                <td><i className="fa-solid fa-ear-listen font-icon me-2"></i>Rechargeable Digital Aids</td>
                <td><i className="fa-solid fa-indian-rupee-sign font-icon me-2"></i>₹32,990 Onwards</td>
              </tr>
              <tr>
                <td><i className="fa-solid fa-ear-listen font-icon me-2"></i>Invisible &amp; Bluetooth Aids </td>
                <td><i className="fa-solid fa-indian-rupee-sign font-icon me-2"></i>₹63,990 Onwards</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      {/* Best Brand We Offer */}

          <section className="container my-5">
        <h4 className="section-title mb-4">Brands We Deal In:</h4>
        <div className="row g-4">
          {[
            {
              brand: "Signia",
              image: signiaImg,
              models: "Silk, Pure, Motion, Insio",
            },
            {
              brand: "Phonak",
              image: phonakImg,
              models: "Audeo, Virto, Naida, Paradise",
            },
            {
              brand: "ReSound",
              image: resoundImg,
              models: "Nexia, Omnia, Key, Enzo, Magna",
            },
          ].map((item, idx) => (
            <div className="col-md-6 col-lg-4" key={idx}>
              <div className="card h-100 shadow-sm text-center p-4">
                <div className="mb-3">
                  <img src={item.image} className="card-img-top" alt={`${item.brand} Hearing Aids`} />
                </div>
                <h5 className="card-title">{item.brand}</h5>
                <p className="card-text">{item.models}</p>
              </div>
            </div>
          ))}
        </div>

        {/* One Download Button at Bottom */}
        <div className="text-center mt-3">
          <a onClick={() => setIsFormOpen(true)} className="btn download-btn shadow fw-bold">
            <i className="fa-solid fa-download"></i> Download Price List
          </a> {isFormOpen && <LeadFormPOPUP onClose={() => setIsFormOpen(false)} />}
        </div>






      </section>
      {/* Hearing Aids Section */}

      <section className="container my-5">
        <h3 className="section-title mb-4 text-center">
          Nearby Clinics and Hearing Aid Stores in Lucknow
        </h3>

        <p className="mb-3">
          <strong>SFL Hearing Solutions</strong> proudly provides trusted hearing care services across
          <strong> Lucknow</strong>, <strong>Ghaziabad</strong>, <strong>Noida</strong>, <strong>Faridabad</strong>, and <strong>Gurgaon</strong>.
        </p>

        <p className="mb-3">
          If you're searching online for terms like <em><span className="tag me-2">“hearing aid clinic near me”</span></em> <em><span className="tag me-2">“ear machine shop near me”</span></em>
          <em><span className="tag me-2">“Phonak hearing aid center near me”</span></em> or <em><span className="tag me-2">“digital hearing aids cost”</span></em> there's a high chance you'll find us at the top.
        </p>

        <p className="mb-3">
          At <strong>SFL Hearing Solutions</strong>, our friendly and experienced audiologists are here to help you or your loved ones
          find the right hearing solution - whether you're looking for an invisible ear machine, a budget-friendly digital aid,
          or simply expert advice that cares.
        </p>
      </section>

      {/* Hearing Aids Type and Offer */}

      <section className="container">
        <h4 className="section-title mb-4">Hearing Aid Types We Offer</h4>

        <div className="row justify-content-md-center g-4">
          {/* digital */}
          <div className="col-md-6 col-lg-3">
            <div className="card h-100 shadow-sm">
              <img
                src={BTE} width="190" height="143" fetchpriority="high"
                alt="hearing aids"

                className="img-fluid w-100 rounded"
                style={{ height: '100%', objectFit: 'cover', maxHeight: '500px' }}
              />
              <div className="card-body">
                <h4 className="card-title">Digital Hearing Aids:</h4>
                <p>
                  <i className="fa-solid fa-bolt  me-2 font-icon"></i>
                  <strong>Features:</strong> For comfort and clarity, digital hearing aids are the best
                  option.
                </p>
                <p>
                  <i className="fa-solid fa-children text-success me-2 "></i>
                  <strong>Ideal For:</strong> All Ages
                </p>
              </div>
            </div>
          </div>

          {/* IIC */}

          <div className="col-md-6 col-lg-3">
            <div className="card h-100 shadow-sm">
              <img
                src={CIC} width="190" height="143" fetchpriority="high"
                alt="hearing aids"

                className="img-fluid w-100 rounded"
                style={{ height: '100%', objectFit: 'cover', maxHeight: '500px' }}
              />
              <div className="card-body">
                <h4 className="card-title">Invisible Hearing Aids:</h4>
                <p>
                  <i className="fa-solid fa-eye-slash  me-2 font-icon"></i>
                  <strong>Features:</strong> Discreet options like CIC and IIC that are almost invisible
                  when worn.
                </p>
                <p>
                  <i className="fa-solid fa-briefcase text-success me-2"></i>
                  <strong>Ideal For:</strong> Working Professionals
                </p>
              </div>
            </div>
          </div>

          {/* Rechargeable */}

          <div className="col-md-6 col-lg-3">
            <div className="card h-100 shadow-sm">
              <img
                src={RechargeableHA} width="190" fetchpriority="high"
                height="143" alt="hearing aids"

                className="img-fluid w-100 rounded "
                style={{ height: '100%', objectFit: 'cover', maxHeight: '500px' }}
              />
              <div className="card-body">
                <h4 className="card-title">Rechargeable Aids</h4>
                <p>
                  <i className="fa-solid fa-battery-full  me-2 font-icon"></i>
                  <strong>Features:</strong> Easily connect with your smartphone for calls, music, and
                  more.
                </p>
                <p>
                  <i className="fa-solid fa-user text-success me-2"></i>
                  <strong>Ideal For:</strong> Seniors
                </p>
              </div>
            </div>
          </div>

          {/* Bluetooth */}

          <div className="col-md-6 col-lg-3">
            <div className="card h-100 shadow-sm">
              <img
                src={BluetootHA} width="190" fetchpriority="high"
                height="143" alt="hearing aids"

                className="img-fluid w-100 rounded "
                style={{ height: '100%', objectFit: 'cover', maxHeight: '500px' }}
              />
              <div className="card-body">
                <h5 className="card-title">Bluetooth Hearing Aids</h5>
                <p>
                  <i className="fa-solid fa-mobile-screen-button me-2 font-icon"></i>
                  <strong>Features:</strong> Easily connect with your smartphone for calls, music, and
                  more.
                </p>
                <p>
                  <i className="fa-solid fa-user-gear text-success me-2"></i>
                  <strong>Ideal For:</strong> Tech-savvy Users
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Right Hearing Device */}

      <section className="container mt-5">
        <div className="row align-items-center">
          <div className="col-md-7">
            <h4 className="fw-bold mb-4 heading">
              <i className="fa-solid fa-ear-listen me-2"></i>
              Find the Right Hearing Device for You
            </h4>
            <p className="fs-5 text-muted">
              Whether you call it a hearing machine, ear device, <em>kan wali machine</em>, or ear sound machine - we have the perfect solution for:
            </p>

            <ul className="list-unstyled fs-5 mt-3">
              <li><i className="fa-solid fa-check-circle text-success me-2"></i> Mild to profound hearing loss</li>
              <li><i className="fa-solid fa-check-circle text-success me-2"></i> One ear or both ears</li>
              <li><i className="fa-solid fa-check-circle text-success me-2"></i> Senior citizens</li>
              <li><i className="fa-solid fa-check-circle text-success me-2"></i> Young adults and working professionals</li>
            </ul>

            <div className="mt-3">
              <a onClick={() => setIsFormOpen(true)} className="btn download-btn shadow fw-bold">
                <i className="fa-solid fa-download"></i> Download Price List
              </a> {isFormOpen && <LeadFormPOPUP onClose={() => setIsFormOpen(false)} />}
            </div>
          </div>

          <div className="col-md-5 mt-4 mt-md-0 text-center">
            <img src={righthearingaids} fetchpriority="high"
              alt="Main" className="main-img" />
          </div>
        </div>
      </section>

      {/* Final CTA */}

      <section className="container">
        <div className="container">
          <div className="cta-section text-center my-5">
            <p className="h4">
              <strong>
                <i className="fa-solid fa-volume-high me-2"></i> Visit your nearest SFL center and book a Hearing Test today.
              </strong>
            </p>
            <p className="h5">
              Take the first step toward clearer hearing and a better quality of life with SFL Hearing
              Solutions.
            </p>
            <a
              href="tel:+919015401540"
              className="btn btn-custom btn-lg ms-3 d-none d-lg-inline fw-bold text-decoration-none"
            >
              <i className="fa-solid fa-phone me-2 mt-3"></i>Contact Us
            </a>
          </div>
        </div>
      </section>

      {/* Appointment Form */}

      <section className="enquiry-section py-5">
        <div className="container">
          <h4 className="form-title section-title fw-bold">Book a Hearing Test</h4>
          <div className="row align-items-center py-3 g-4">
            {/* Left Section */}
            <div className="col-lg-6 image-wrapper">
              <div className="image-box">
                <img src={Bookhearingtest} fetchpriority="high"
                  alt="Main" className="main-img" />

              </div>
            </div>
            {/* Right Section */}
            <div className="col-lg-6">

              <ShortLeadForm />

            </div>
          </div>
        </div>
      </section>
<FAQ />
      {/* Testimonials Section */}

      <section className="container my-5">
        <h4 className="text-center mb-4">What Our Customers Say</h4>
        <div className="row g-4">
          {[
            {
              name: "Pankaj Thakur",
              review:
                "Sound for life is excellent... They have good trained audiologist... Thanx Dr. Mohana for your kind suggestion and treatment.",
              stars: 5,
            },
            {
              name: "Archana Singh",
              review:
                "I am very satisfied with the products and services... trust this clinic, this is really reliable.",
              stars: 4,
            },
            {
              name: "Praphul Fernandis",
              review:
                "The staff was attentive and knowledgeable... creating a comfortable environment... overall service left a lasting positive impression.",
              stars: 3.5,
            },
          ].map((t, idx) => (
            <div className="col-md-6 col-lg-4" key={idx}>
              <div className="card h-100 shadow-sm border-0 p-4">
                <div className="mb-3">
                  <i className="fa-solid fa-quote-left text-primary fa-2x"></i>
                </div>
                <p className="card-text">“{t.review}”</p>
                <div className="d-flex align-items-center mt-3">
                  <div>
                    <h5 className="mb-0 fw-bold">{t.name}</h5>
                    <div className="text-warning">
                      {[...Array(Math.floor(t.stars))].map((_, i) => (
                        <i key={i} className="fa-solid fa-star"></i>
                      ))}
                      {t.stars % 1 !== 0 && <i className="fa-solid fa-star-half-stroke"></i>}
                      {[...Array(5 - Math.ceil(t.stars))].map((_, i) => (
                        <i key={i} className="fa-regular fa-star"></i>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Video Testimonial */}

        <div className="row mt-5">
          <div className="col-lg-8 mx-auto">
            <h4 className="text-center mb-3">
              <i className="fa-solid fa-video me-2 text-danger"></i>Watch What Our Patients Say
            </h4>
            <div className="ratio ratio-16x9 shadow-sm rounded">
              <div>
                <LiteYouTubeEmbed
                  id="D9tDd5JXNUA"
                  title="What’s new in Material Design for the web (Chrome Dev Summit 2019)"
                />
              </div>
            </div>
          </div>
        </div>

        {/* Write Review Button */}

        <div className="text-center mt-5">
          <a href="https://g.page/r/CR7IQsjxt4hdEAE/review" className="btn btn-custom btn-lg shadow">
            <i className="fa-solid fa-pen-to-square me-2"></i>Write Your Review
          </a>
        </div>
      </section>

      {/* WHY SFL */}

      <section className="container">
        <h5 className="text-center">
          Why People Trust <span className="why">SFL Hearing Solutions</span>
        </h5>
        <p className="fs-5 text-center text-muted">
          Trusted by thousands across Lucknow for hearing care, digital hearing aids, and expert consultation.
        </p>

        <div className="row g-4">
          {[
            {
              icon: "fa-certificate",
              title: "Certified Centre",
              desc: "We are a trusted and certified hearing aid centre in Lucknow.",
            },
            {
              icon: "fa-user-md",
              title: "Experienced Audiologists",
              desc: "Our team includes Professional Audiologists and Fitting experts.",
            },
            {
              icon: "fa-users",
              title: "50,000+ Happy Users",
              desc: "We’ve helped over 50,000 happy customers hear better.",
            },
            {
              icon: "fa-tags",
              title: "Transparent Pricing",
              desc: "Clear and honest pricing – no hidden charges.",
            },
            {
              icon: "fa-clinic-medical",
              title: "Clinics in Lucknow",
              desc: "Visit us in Lucknow, Noida, Ghaziabad, Gurgaon & more.",
            },
            {
              icon: "fa-headset",
              title: "Responsive Support",
              desc: "We offer full range of brands & models.",
            },
          ].map((item, i) => (
            <div className="col-md-6" key={i}>
              <div className="d-flex align-items-start p-3 border rounded-4 shadow-sm h-100">
                <div className="me-3 mt-1">
                  <i className={`fas ${item.icon} whyus fa-2x whyus`}></i>
                </div>
                <div>
                  <h5 className="fw-semibold mb-1">{item.title}</h5>
                  <p className="mb-0 text-muted small">{item.desc}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* CTA Section */}
      <section className="container my-5">
        <div className="bg-white border shadow rounded p-4">
          <div className="text-center mb-4">
            <h5 className="fw-bold">🎧 Ready to Buy a Hearing Aid?</h5>
          </div>
          <p className="fs-5 text-muted">
            Depending on your needs, preferences, and financial situation, we assist you in selecting the
            appropriate hearing aid for moderate loss, old age, or invisible choices.
          </p>

          <p className="fs-5 text-muted">Explore the latest models from <strong>ReSound, Phonak, Signia,</strong> and other companies.</p>
          <div className="mb-4">
            <h5 className="mb-3">
              <i className="fa-solid fa-magnifying-glass text-primary me-2"></i>
              <strong>Top Searches Our Users Look For:</strong>
            </h5>
            <div className="d-flex flex-wrap gap-2">
              {[
                "Digital hearing machine price",
                "Best hearing aid in Lucknow",
                "Signia Silk X price",
                "Phonak hearing aid cost",
                "Ear machine price in Lucknow"
              ].map((item, index) => (
                <span
                  key={index}
                  className="badge bg-light text-dark border px-3 py-2"
                  style={{ fontSize: "0.9rem" }}
                >
                  <i className="fa-solid fa-tags me-1 text-primary"></i> {item}
                </span>
              ))}
            </div>
          </div>

          <div className="sfl-highlight-box text-center mt-4 p-4 rounded">
            <h5 className="sfl-highlight-heading fw-semibold">
              Sound For Life – Your ears deserve the best.
            </h5>
            <p className="sfl-highlight-subtext mt-2">
              Let us help you hear clearly again with the right device near you.
            </p>
          </div>
        </div>
      </section>
      <section className="container my-5">
        <div className="container-fluid py-5" style={{ background: 'linear-gradient(90deg, #006ea1, #006ea1)', color: '#fff' }}>
          <div className="container text-center">
            <h5 className="fw-bold mb-3">
              <i className="fa-solid fa-calendar-check me-2"></i>
              Don’t Wait to Hear Better!
            </h5>
            <p className="fs-5 mb-4">
              Get the best <strong>digital hearing aids</strong> and <strong>kan sunne wali machine</strong> near you
              at affordable prices from trusted experts.
            </p>

            <div className="d-flex flex-column flex-md-row justify-content-center gap-3">
              <a
                href="tel:+919015401540"
                className="btn btn-warning btn-lg fw-bold px-4 shadow"
              >
                <i className="fa-solid fa-phone me-2"></i> Contact Us
              </a>

              <a
                href="https://wa.me/919015706707"
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-light btn-lg fw-bold px-4 text-dark shadow"
              >
                <i className="fa-brands fa-whatsapp me-2"></i> WhatsApp Chat
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Buy a Hearing Aid? Section */}



      {/* Ffooter Section */}

      <Footer />
    </>
  );
};

export default PriceLucknow;